import { render, staticRenderFns } from "./AssociationTypesSelect.vue?vue&type=template&id=f504b5b8&scoped=true&lang=pug"
import script from "./AssociationTypesSelect.vue?vue&type=script&lang=js"
export * from "./AssociationTypesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f504b5b8",
  null
  
)

export default component.exports